import React from "react";
import { Container } from "../styled.ts";

export const LinkIcon = ({ url = "#", icon = <></> }) => {
  return (
    <Container
      as="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ cursor: "pointer" }}
    >
      {icon}
    </Container>
  );
};
